import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { FormattedMessage } from "react-intl";

const Row: React.FC<{
  invoice: {
    number: number;
    status: String;
    id?: String;
    handleOpenEdinModal: any;
    trello_url: string;
    project: any | null;
    company: any;
    date: string;
  };
}> = ({ invoice }, props) => {
  const { number, status, handleOpenEdinModal, company, date } = invoice;
  const handleEditQuote = () => {
    handleOpenEdinModal(invoice);
  };

  const renderStatus = () => {
    switch (status) {
      case "draft":
        return (
          <FormattedMessage id="general-status.draft" defaultMessage="draft" />
        );
      case "sent":
        return (
          <FormattedMessage id="general-status.sent" defaultMessage="sent" />
        );
      case "closed":
        return (
          <FormattedMessage
            id="general-status.closed"
            defaultMessage="closed"
          />
        );
      default:
        console.error("unexpected status: ", status);
        return (
          <FormattedMessage
            id="general-status.unexpected-status"
            defaultMessage="unexpected status"
          />
        );
    }
  };

  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": {
          border: 0,
        },
      }}
      style={{ cursor: "pointer" }}
      onClick={(event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        event.nativeEvent.stopPropagation();
        handleEditQuote();
      }}
    >
      <TableCell component="th" scope="row">
        #{number}
      </TableCell>
      <TableCell component="th" scope="row">
        {company?.name}
      </TableCell>
      <TableCell component="th" scope="row">
        {renderStatus()}
      </TableCell>
      <TableCell component="th" scope="row">
        {date}
      </TableCell>
    </TableRow>
  );
};

export default Row;
